import { DottedBorder } from "@ui/components/core/GradientBorder";
import { cn } from "@ui/lib/utils";

interface QuoteProps {
  author?: string | null;
  className?: string;
  quote: string;
  title?: string | null;
}

export default function Quote({ quote, author, title, className }: QuoteProps) {
  return (
    <div className={cn("relative pl-20", className)}>
      <DottedBorder side='left' />
      <p className='f-paragraph-02 mb-16'>{quote}</p>
      {author && <p className='f-paragraph-02 mb-2'>{author}</p>}
      {title && <p className='f-paragraph-04 text-light'>{title}</p>}
    </div>
  );
}
